<!--
// app/components/Shared/icons/PrevIcon.vue
-->
<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
};

withDefaults(defineProps<Props>(), {
  height: 14,
  width: 14,
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    class="rotate-180 rtl:rotate-0"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
  >
    <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
  </svg>
</template>

<style scoped></style>
